export default __webpack_public_path__ + "static/media/mitHund.9624b90d.jpg";